(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('RegistrationController', RegistrationController);

    RegistrationController.$inject = ['$rootScope', '$state', '$stateParams', 'RegistrationService', 'ProjectService', '$localStorage', '$translate', '$log', 'Principal', 'CartFactory', '$q','AlertService'];

    function RegistrationController($rootScope, $state, $stateParams, RegistrationService, ProjectService, $localStorage, $translate, $log, Principal, CartFactory, $q,AlertService) {

        // VARIABLES
        var vm = this;
        vm.exhibitor = {};

        vm.salutations = [];
        vm.academictitles = [];
        vm.countries = [];
        vm.labels = [];
        vm.readOnly = false;
        vm.bookLogo = false;
        vm.logo = null;
        vm.logoUploadStatus = null;
        vm.logoPreviewThumbnail = null;
        vm.logoIsPaid = null;
        vm.steinexpo = $localStorage.projectinfo.steinexpo;

        vm.lang = $translate.use();

        vm.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        vm.invoicePaidBy = [
            {id: 0, value: $translate.instant('registration.form.mainExhibitor')},
            {id: 1, value: $translate.instant('registration.form.coExhibitor')}
        ];


        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.uploadLogo = uploadLogo;
        vm.register = register;
        vm.goBack = goBack;

        vm.mainExhibitorDataSet = $localStorage.exhibitorDataSet;

        vm.coExhibitorId = $stateParams.id;
        vm.registered = false;

        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.countries);
            translateComboBoxValues(vm.salutations);
            translateComboBoxValues(vm.academictitles);
        });


        loadProjectData();

        loadExhibitor();

        getExhibitorAuthorities();


        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                $log.debug('RegistrationController | authorities', identity);
                if (identity.authorities.indexOf('AUTHORIZATION_PENDING') !== -1) {
                    vm.readOnly = true;
                    $log.debug('RegistrationController | readonly mode', vm.readOnly);
                }
                if (identity.authorities.indexOf('AUTHORIZED') !== -1 || identity.authorities.indexOf('ESC_INACTIVE') !== -1) {
                    vm.registered = true;
                    vm.mainExhibitorDataSet = true;
                }
            }, function() {
                $log.debug('RegistrationController | ERROR IDENTITY', value);

            });
        }


        // FUNCTIONS
        function loadExhibitor() {
            if (vm.coExhibitorId) {
                if (vm.coExhibitorId > 0) {
                    RegistrationService.getCurrentLogo(vm.coExhibitorId).then(fillLogo, error);
                    RegistrationService.getCurrentExhibitor(vm.coExhibitorId).then(fillExhibitor, error);
                } else {
                    if ($localStorage.coExhibitors) {

                        var index = 0
                        var found = false;
                        angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                            if (exhibitor.id == vm.coExhibitorId) {
                                found = true;
                            }
                            if (!found)
                                index++;
                        });
                        if (found) {
                            vm.exhibitor = $localStorage.coExhibitors[index];
                        } else {
                            vm.exhibitor.coExhibitor = 1;
                            vm.exhibitor.id = vm.coExhibitorId;
                        }
                    } else {
                        vm.exhibitor.coExhibitor = 1;
                        vm.exhibitor.id = vm.coExhibitorId;
                    }
                }
            } else {
                RegistrationService.getCurrentLogo().then(fillLogo, error);
                RegistrationService.getCurrentExhibitor().then(fillExhibitor, error);
            }
        }

        function fillExhibitor(response) {
            $log.debug("RegistrationController | Exhibitor:", response);
            vm.exhibitor = response.data;
        }

        function fillLogo(response) {
            $log.debug("RegistrationController | Exhibitor:", response);
            vm.bookLogo = response.data.logo || response.data.paid ? 1 : 0;
            vm.logo = vm.bookLogo ? 'USE_EXISTING' : null;
            vm.logoPreviewThumbnail = response.data.logo;
            vm.logoIsPaid = response.data.paid;
        }

        function register() {
            // Add registrationfee to cart
            $log.debug('RegistrationController | Posting exhibitor...', vm.exhibitor);

            if (vm.coExhibitorId) {
                if (vm.coExhibitorId < 0) {
                    addCoExhibitorRegistrationFeeToCart(vm.coExhibitorId);
                }
            } else {
                if (!vm.registered) {
                    addRegistrationFeeToCart();
                }
            }

            if (vm.steinexpo) {
                if (vm.bookLogo) {
                    if (!vm.logoIsPaid) {
                        var isAlreadyInCart;

                        if (vm.coExhibitorId) {
                            isAlreadyInCart = CartFactory.getCart().find(function (item) {
                                return item.type === 'CoExhibitorLogoFee' && item.cartPositionBookedForId === vm.coExhibitorId;
                            });

                            if (!isAlreadyInCart) {
                                addCoExhibitorLogoFeeToCart(vm.coExhibitorId);
                            }
                        } else {
                            isAlreadyInCart = CartFactory.getCart().find(function (item) {
                                return item.type === 'LogoFee';
                            });

                            if (!isAlreadyInCart) {
                                addLogoFeeToCart();
                            }
                        }
                    }
                } else if (vm.logo) {
                    delete vm.logo;
                }
            }

            if (vm.coExhibitorId) {
                if (vm.coExhibitorId < 0) {
                    var index = 0;
                    var update = false;
                    angular.forEach($localStorage.coExhibitors, function (exhibitor) {
                        if (exhibitor.id == vm.coExhibitorId) {
                            update = true;
                            return;
                        }
                        if (!update)
                            index++;
                    });
                    if (update) {
                        $localStorage.coExhibitors[index] = vm.exhibitor;
                    } else {
                        $localStorage.coExhibitors.push(vm.exhibitor);
                    }
                    goHome();
                } else {
                    RegistrationService.storeAddressData(vm.exhibitor, vm.coExhibitorId).then(storedAddressData, error);
                    $localStorage.exhibitorDataSet = true;
                }
            } else {
                RegistrationService.storeAddressData(vm.exhibitor).then(storedAddressData, error);
                $localStorage.exhibitorDataSet = true;
            }
        }

        function goBack() {
            $state.go('home', {}, {reload: true, notify: true});
        }

        function storedAddressData() {
            if (vm.steinexpo && vm.logo && vm.logo !== 'USE_EXISTING') {
                RegistrationService.storeLogoData(vm.logo, vm.coExhibitorId ? vm.coExhibitorId : null).then(function () {
                    goHome();
                }, function (error) {
                    // Ignore unhandled error
                    return $q.reject(error);
                });
            } else {
                goHome();
            }
        }

        function goHome() {
            Principal.identity();

            if (vm.steinexpo) {
                if (vm.coExhibitorId && vm.coExhibitorId < 0) {
                    var hasAuthority = Principal.hasAnyAuthority(['PRE_AUTHORIZED', 'ESC_INACTIVE']);

                    if (hasAuthority) {
                        $state.go('nomenclature', {id: vm.coExhibitorId});
                    } else {
                        $state.go('home', {}, {reload: true, notify: true});
                    }
                } else {
                    Principal.hasAuthority('PRE_AUTHORIZED').then(function (hasAuthority) {
                        if (hasAuthority) {
                            $state.go('nomenclature');
                        } else {
                            $state.go('home', {}, {reload: true, notify: true});
                        }
                    }, function () {
                        $state.go('home', {}, {reload: true, notify: true});
                    });
                }
            } else {
                $state.go('home', {}, {reload: true, notify: true});
            }
        }

        function reloadAuthorities() {
            Principal.identity();
        }

        function loadProjectData() {
            $log.debug("RegistrationController | Load project data for Project-ID: ", $localStorage.project);
            ($localStorage.salutations !== undefined) ? vm.salutations = $localStorage.salutations : ProjectService.loadSalutations($localStorage.project).then(successSalutations, error);
            ($localStorage.academictitles !== undefined) ? vm.academictitles = $localStorage.academictitles : ProjectService.loadAcademicTitles($localStorage.project).then(successAcademicTitles, error);
            ($localStorage.countries !== undefined) ? vm.countries = $localStorage.countries : ProjectService.loadCountries($localStorage.project).then(successCountries, error);
            RegistrationService.loadFees().then(successFees, error);
            ProjectService.loadProjectLabels('general').then(succesLabels, error);
        }


        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function successCountries(response) {
            $log.debug('RegistrationController | Getting Countries...', response.data);
            vm.countries = response.data;
            translateComboBoxValues(vm.countries);
            $localStorage.countries = vm.countries;
        }

        function successFees(response) {
            $log.debug('RegistrationController | Getting Fees...', response);
            vm.fees = response.data;
            if (vm.fees) {
                vm.registrationFee = vm.fees.registrationFee;
                vm.registrationFeeCoExhibitor = vm.fees.registrationFeeCoExhibitor;
                vm.registrationFeeCartLabel = vm.fees.translations;
                vm.logoFee = vm.fees.logoFee;
                vm.logoFeeCartLabel = vm.fees.logoFeeLabel;
            }
        }

        function succesLabels(response) {
            $log.debug('RegistrationController | Getting General-Labels...', response.data);
            var labels = [];
            angular.forEach(response.data, function (value) {
                labels[value.key] = value.translations;
            });
            vm.labels = labels;
        }

        function successSalutations(response) {
            $log.debug('RegistrationController | Getting Salutations...', response.data);
            vm.salutations = response.data;
            translateComboBoxValues(vm.salutations);
            $localStorage.salutations = vm.salutations;
        }

        function successAcademicTitles(response) {
            $log.debug('RegistrationController | Getting Academictitles...', response.data);
            vm.academictitles = response.data;
            translateComboBoxValues(vm.academictitles);
            $localStorage.academictitles = vm.academictitles;
        }

        function error(response) {
            $log.debug('RegistrationController | ERROR:', response);
        }

        function addRegistrationFeeToCart() {
            var fee = {
                cartPositionPrice: vm.registrationFee,
                cartPositionParent: null,
                cartPositionLabel: vm.registrationFeeCartLabel,
                cartPositionBookedFor: null,
                type: 'Fee',
                cartPositionId: null
            };

            $log.debug('RegistrationController | Cart entry for registrationfee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showFeeAddedToCart = true;
        }

        function addCoExhibitorRegistrationFeeToCart(id) {
            var fee = {
                cartPositionPrice: vm.registrationFeeCoExhibitor,
                cartPositionParent: null,
                cartPositionLabel: vm.registrationFeeCartLabel,
                cartPositionBookedFor: '- ' + vm.exhibitor.company,
                cartPositionBookedForId: id,
                coExhibitor: vm.exhibitor,
                type: 'CoExhibitorFee'
            };

            // CartFactory.removeFee();
            $log.debug('RegistrationController | Cart entry for registrationfee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showCoExhibitorFeeAddedToCart = true;

        }

        function addLogoFeeToCart() {
            var fee = {
                cartPositionPrice: vm.logoFee,
                cartPositionParent: null,
                cartPositionLabel: vm.logoFeeCartLabel,
                cartPositionBookedFor: null,
                type: 'LogoFee',
                cartPositionId: null,
                logoId: vm.logo
            };

            $log.debug('RegistrationController | Cart entry for logofee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showLogoFeeAddedToCart = true;
        }

        function addCoExhibitorLogoFeeToCart(id) {
            var fee = {
                cartPositionPrice: vm.logoFee,
                cartPositionParent: null,
                cartPositionLabel: vm.logoFeeCartLabel,
                cartPositionBookedFor: '- ' + vm.exhibitor.company,
                cartPositionBookedForId: id,
                coExhibitor: vm.exhibitor,
                type: 'CoExhibitorLogoFee',
                logoId: vm.logo
            };

            // CartFactory.removeFee();
            $log.debug('RegistrationController | Cart entry for logofee:', fee);

            CartFactory.addFee(fee);

            $localStorage.showCoExhibitorLogoFeeAddedToCart = true;
        }

        function pageLoaded() {
            return (vm.academictitles && vm.countries && vm.salutations && vm.exhibitor && vm.labels);
        }

        function uploadLogo(file) {
            if (!file) {
                return;
            }

            vm.logoUploadStatus = 0;
            RegistrationService.uploadLogo(file, vm.logo).then(function (data) {
                vm.logo = data.fileName;
                vm.logoPreviewThumbnail = data.fileDownloadUri;
                vm.logoUploadStatus = null;
            }, function () {
                vm.logoUploadStatus = null;
            }, function (event) {
                vm.logoUploadStatus = parseInt(100.0 * event.loaded / event.total);
            });
        }

        return vm;
    }
})();
